import * as THREE from 'three';
// import { EdgesGeometry, MeshStandardMaterial } from 'three';
import {  GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { FikoGrup } from '../FikoGrup';
import { FikoObje3D } from '../FikoObje3D';
import { FikoSahne } from '../FikoSahne';
import { fikoObjeyiStlIndir } from './FikoSTLDisaAktar';
import { fikoObjeyiStepIndir, fikoStepAyarlariniDuzenle } from './FikoSTEPDisaAktar';

export class FikoCizimGLB extends FikoGrup {
    override type: any = "FikoCizimGLB";
    /** */
    sayac = 1;

    override komutlar = [
        {
            isim: "Gizle / Göster",
            simge: "eye",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.ciz();
            }
        },
        {
            isim: "STL olarak indir",
            simge: "download",
            tiklandi: () => {
                // STL renk/doku tasimaz — yalnizca geometri disari aktarilir.
                try { fikoObjeyiStlIndir(this, this.name); }
                catch (e: any) {
                    console.error('STL disa aktarim hatasi', e);
                    alert('STL olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP olarak indir (B-Rep)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'brep', this.name); }
                catch (e: any) {
                    console.error('STEP (B-Rep) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP olarak indir (AP242 Tessellated)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'tessellated', this.name); }
                catch (e: any) {
                    console.error('STEP (Tessellated) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP ayarları...",
            simge: "cog",
            tiklandi: () => { fikoStepAyarlariniDuzenle(); }
        }
    ]

    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        
        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/gltf.webp";
    }

    dosyadan(dosya: any) {
        let _this = this;


        const loader: GLTFLoader = new GLTFLoader();

        loader.load(URL.createObjectURL(dosya), function (geometry: FikoObje3D & any) {
            _this.add(...geometry.scene.children[0].children);

            _this.sahne.anaGosterim.ciz();
            _this.sahne.anaGosterim.FikoYT.degisti.emit();

            _this.traverse((elm: any) => {
                if (elm.type == "Mesh") {
                    //@ts-ignore
                    let material: MeshStandardMaterial = elm.material;

                    material.polygonOffset = true;
                    material.polygonOffsetFactor = 1;
                    material.polygonOffsetUnits = 1

                    elm.material = material;

                    var edge: THREE.EdgesGeometry = new THREE.EdgesGeometry(elm.geometry);
                    var edgeLine = new THREE.LineSegments(edge, new THREE.LineBasicMaterial({ color: 0x000000 }));
                    elm.add(edgeLine);
                }
            });

        });
        return this;
    }

}